module.exports = require('./cjs/nivo-core')
